import { render, staticRenderFns } from "./StockistForm.vue?vue&type=template&id=654f0036&"
import script from "./StockistForm.vue?vue&type=script&lang=js&"
export * from "./StockistForm.vue?vue&type=script&lang=js&"
import style0 from "./StockistForm.vue?vue&type=style&index=0&id=654f0036&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports